import styles from './TrustStrip.module.css';

const TIERS = [
  { name: 'Verified', desc: 'Checked and confirmed in real time.' },
  { name: 'Researched', desc: 'Assembled by the AI engine from multiple sources.' },
  { name: 'Partial', desc: 'Best available, flagged so you know.' },
];

export default function TrustStrip() {
  return (
    <section className={styles.section}>
      <div className={styles.inner}>
        <p className={styles.statement}>
          Every enriched field shows its confidence tier: we tell you how sure we are
          instead of pretending everything is gospel.
        </p>
        <div className={styles.tiers}>
          {TIERS.map((t) => (
            <div key={t.name} className={styles.tier}>
              <span className={`${styles.dot} ${styles[t.name.toLowerCase()]}`} aria-hidden="true" />
              <div>
                <span className={styles.tierName}>{t.name}</span>
                <span className={styles.tierDesc}>{t.desc}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
